import pluralize from 'pluralize';
import React from 'react';
import { useApi, useWorkspace } from '~/contexts';
import BulkActionModal from '~/components/bulk-action/BulkActionModal';
import ClientDetails from './ClientDetails';

export default function BulkUnarchive({ ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  return (
    <BulkActionModal
      title="Bulk Unarchive"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .clients()
          .bulkSetRecordStatus(ids, 'active')
          .then((r) => r.data)
      }
      renderRow={ClientDetails}>
      {`Are you sure you want to unarchive ${ids.length} ${pluralize('client', ids.length)}? Note that this will not unarchive any projects within the clients. Projects must be unarchived separately.`}
    </BulkActionModal>
  );
}
